import { getCachedScript } from "./scriptCache.js";

const handleClick = (script, argument) => {
  const code = getCachedScript();
  if (code) {
    window.jsx.evalScript(
      `run(${script}(${JSON.stringify(argument)}));`,
      function (result) {
        // Logic after executing the script
      },
    );
  }
  return false;
};

export default handleClick;
